import React from 'react';
import { get, find } from 'lodash';

// local dependencies
import { outboundCalls as OutboundCallsView } from 'ui/views/widgets/outboundCalls';
import * as pageLevelPreloader from 'modules/page-level-preloader';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import * as errorOverlay from 'utils/errorOverlay';
import * as successOverlay from 'utils/successOverlay';
import { GLOBAL_LABELS } from 'constants/common';
import { getLabel } from 'utils/getLabel';
import { OutboundCallsService } from 'services/outboundCalls';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { OutboundCalls } from 'ui/containers/OutboundCalls';
 *
 * // render
 * <OutboundCalls propName='propValue'/>
 */
export class OutboundCalls extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.state = this.composeStateFromProps();

        this._bind();
        this.outboundCallsService = new OutboundCallsService();
    }

    _bind() {

        this.onFormSubmit = this.onFormSubmit.bind( this );
        this.composeStateFromProps = this.composeStateFromProps.bind( this );
        this.handleFormChangeCallback = this.handleFormChangeCallback.bind( this );
    }

    composeStateFromProps() {
        log.debug( 'OutboundCalls.composeStateFromProps()' );

        return {
            options: get( this.props, 'options', {} ),
            fields: this.props.fields,
            values: get( this.props, 'values' ),
        };
    }

    handleFormChangeCallback( /* { values, field } */ ) {
        log.debug( 'OutboundCalls.handleFormChangeCallback()' );

        /*-------------------*/

        /*-------------------*/
    }

    /**
     * action executed when user clicks on form submit
     */
    async onFormSubmit ( formData ) {
        log.debug( 'OutboundCalls.onFormSubmit()' );

        const successAction = find( this.props.actions, { name: 'submit' } );

        // close overlay
        this.props.onCancelClick();

        // show page preloader
        pageLevelPreloader.show();

        const { status } = await this.outboundCallsService.submitFormData( {
            url: successAction.url,
            data: {
                ...this.props.requestPayload,
                data: formData
            }
        } );

        // hide page preloader
        pageLevelPreloader.hide();

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
            successOverlay.open( { message: getLabel( GLOBAL_LABELS.DISPLAY_TEXT_DONE_SUCCESSFULLY ), } );

        } else {
            errorOverlay.open();
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <OutboundCallsView
                { ...this.props }
                { ...this.state }
                onFormSubmit={ this.onFormSubmit }
                onChangeCallBack={ this.handleFormChangeCallback }
            />
        );
    }
}

// set display name
OutboundCalls.displayName = 'Outbound Calls';

// set default props
OutboundCalls.defaultProps = {};

// prop types
OutboundCalls.propTypes = {};
